module.exports = __webpack_public_path__ + "img/news_01.2326614e.jpg";